import apiEndpoints from '@src/lib/apiEndpoints';

import apiRequest from './api';

export const loginOtp = (email: string, password: string) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.LOGIN_OTP}`,
    data: { email, password },
  });
};

export const getUserDetails = () => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.CURRENT_USER}`,
  });
};

//@TODO function name wrong
export const userLogout = () => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.USER_LOGOUT}`,
    data: {},
  });
};

export const refreshTokens = () => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.AUTH_REFRESH_TOKEN}`,
    data: {},
  });
};
